import { z } from '../zod';
import { BadgeIconEnumValidationSchema, FeatureIconEnumValidationSchema } from './enum';

// Copy that only renders on an order bump card, so it is only accepted for
// products with `role: orderbump`.
export const orderBumpCardInputFields = {
  shortDescription: z.string().max(500).nullish().meta({
    description: `Plain-text one-liner shown under the title on the order bump card. Send null to clear. Order bump products only.`,
    example: 'Wrapped in recycled paper with a handwritten note.',
  }),
  callToActionText: z.string().max(200).nullish().meta({
    description: `Accept copy on the order bump card, e.g. "Yes! Add gift wrapping". Send null to clear. Order bump products only.`,
    example: 'Yes! Add gift wrapping',
  }),
  headingText: z.string().max(200).nullish().meta({
    description: `Heading shown above the order bump card, e.g. "Special one time offer". Send null to clear. Order bump products only.`,
    example: 'Special one time offer',
  }),
  features: z
    .array(
      z.object({
        text: z.string().min(1).max(200).meta({ description: 'One line of the list.' }),
        icon: FeatureIconEnumValidationSchema.nullish().meta({
          description:
            'Icon leading the line. Unset, the line leads with a check; `none` draws no icon.',
        }),
      }),
    )
    .max(10)
    .nullish()
    .meta({
      description: `Short list of what the customer gets, shown above the description on the order bump card. Replaces the whole list; send [] or null to clear. Order bump products only.`,
    }),
  calloutText: z.string().max(2000).nullish().meta({
    description: `Call out box under the description on the order bump card. HTML: links and inline emphasis are kept, anything else is removed. Send null to clear. Order bump products only.`,
    example: 'Only <strong>20</strong> left at this price.',
  }),
  calloutIcon: BadgeIconEnumValidationSchema.nullish().meta({
    description: `Icon leading the call out box. Send null to clear. Order bump products only.`,
  }),
};

export const ORDER_BUMP_CARD_FIELDS = Object.keys(orderBumpCardInputFields) as Array<
  keyof typeof orderBumpCardInputFields
>;
